import axiosPost from "./axiosPost";

export const RNHZonaGet = async (credentials, data) => {
    const body = {
        service: "RNHZonaGet",
        params: {
            rnhZonaId: data?.rnhZonaId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
